<script>
import { mapActions } from 'vuex'
import OperationForm from '@/components/fiche-aim/fiche-aim/ajustement/operation/operation-form.vue'

export default {
  components: { OperationForm },
  emits: ['created', 'close'],
  props: {
    ficheAimId: {
      type: Number,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      formValid: false,
      justification: undefined,
      epargnes: [],
    }
  },
  computed: {
    isValid() {
      return this.justification !== undefined && this.totalEpargne > 0
    },
    totalEpargne() {
      return this.epargnes
        .map((r) => r.montantRemboursement)
        .reduce((previousValue, currentValue) => Number(previousValue) + Number(currentValue), 0)
    },
    operationsEpargne() {
      let operations = []
      this.epargnes.forEach((r) => {
        operations.push({
          montant: Number(r.montantRemboursement) * -1,
          posteAIMId: r.posteRemboursement.posteAIMId,
        })
      })
      return operations
    },
  },
  methods: {
    ...mapActions({
      ajuster: 'ficheAIM/ajusterFicheAIM',
    }),
    clear() {
      this.justification = undefined
      this.epargnes = []
    },
    submitAjustement() {
      this.ajuster({
        ficheAIMId: this.ficheAimId,
        explication: this.justification,
        operations: [
          {
            montant: Number(this.totalEpargne),
            posteAIMId: 'EPARGNE',
          },
          ...this.operationsEpargne,
        ],
      }).then((ajustement) => {
        this.clear()
        this.$emit('created', ajustement)
      })
    },
    ajouterEpargne(epargne) {
      this.epargnes.push(epargne)
    },
    removeEpargne(epargne) {
      this.epargnes.splice(this.epargnes.indexOf(epargne), 1)
    },
  },
}
</script>

<template>
  <v-bottom-sheet :value="active" inset origin="left bottom" persistent @close="$emit('closes')">
    <v-form v-model="formValid" @submit.prevent="submitAjustement">
      <v-card>
        <v-card-text>
          <v-row align="center">
            <v-col cols="6">
              <operation-form titre="Épargner" @input="ajouterEpargne" />
            </v-col>
            <v-col cols="6" align-self="center">
              <v-row justify="center" align="center">
                <v-icon color="primary" size="96">mdi-piggy-bank</v-icon>
                <v-col class="d-flex justify-center pt-0" cols="12" align-self="center">
                  <v-chip color="primary">+ {{ totalEpargne }} €</v-chip>
                </v-col>
              </v-row>
              <v-card-text>
                <v-chip-group column>
                  <v-chip v-for="(e, i) in epargnes" :key="i" close @click:close="removeEpargne(e)">
                    {{ e.posteRemboursement.libelle }} :<strong class="pl-1">{{ e.montantRemboursement }}€</strong>
                  </v-chip>
                </v-chip-group>
              </v-card-text>
              <v-textarea
                class="textarea"
                outlined
                label="Justification"
                no-resize
                rows="2"
                required
                v-model="justification"
                :rules="[(v) => !!v || 'Vous devez renseigner une justification']"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn type="submit" @click="clear">Vider</v-btn>
          <v-btn @click="$emit('close')">fermer</v-btn>
          <v-btn type="submit" :disabled="!isValid" color="success">
            <v-fab-transition>
              <v-icon v-if="isValid">mdi-plus</v-icon>
            </v-fab-transition>
            Créer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-bottom-sheet>
</template>
